var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultRecordPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 143,
    viewBox: "0 0 156 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2973_9870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.362 28.5645H18.6709C17.0292 28.5655 15.4549 29.2181 14.294 30.379C13.1331 31.5399 12.4805 33.1141 12.4795 34.7559V146.408C12.4805 148.05 13.1331 149.624 14.294 150.785C15.4549 151.946 17.0292 152.599 18.6709 152.6H140.362C142.004 152.599 143.578 151.946 144.739 150.785C145.9 149.625 146.553 148.05 146.554 146.408V34.7559C146.553 33.114 145.9 31.5397 144.739 30.3788C143.578 29.2179 142.004 28.5653 140.362 28.5645Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.351 113.801H26.6831C23.2639 113.801 20.4917 111.029 20.4917 107.61V8.95899C20.4917 5.53977 23.2639 2.76758 26.6831 2.76758H132.351C135.77 2.76758 138.542 5.53977 138.542 8.95899V107.61C138.542 111.029 135.77 113.801 132.351 113.801Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4519 109.569V10.9192C22.4519 7.5 25.2241 4.72781 28.6433 4.72781H134.311C135.519 4.72781 136.641 5.07881 137.593 5.67659C136.499 3.93118 134.563 2.76758 132.351 2.76758H26.6831C23.2639 2.76758 20.4917 5.53977 20.4917 8.95899V107.61C20.4917 109.823 21.6553 111.758 23.4007 112.853C22.8029 111.9 22.4519 110.778 22.4519 109.57V109.569Z",
    fill: "url(#paint0_linear_2973_9870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.349 23.6113H39.6851V28.1513H119.349V23.6113ZM119.349 40.9465H39.6851V45.4865H119.349V40.9465ZM119.349 58.2855H39.6851V62.8255H119.349V58.2855ZM119.349 75.6207H39.6851V80.1613H119.349V75.6207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1782 60.9668L69.1967 80.9859H49.1782V60.9668Z",
    fill: "url(#paint1_linear_2973_9870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.554 82.637V36.5767L138.542 28.5645V82.6364H146.554V82.637Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.938 86.8041L147.306 147.907C146.875 150.962 144.26 153.233 141.175 153.233H17.8575C14.7726 153.233 12.1583 150.962 11.7268 147.907L0.0619552 65.3419C-0.464225 61.6145 2.42817 58.2842 6.19263 58.2842H44.2758C47.3606 58.2842 49.9749 60.5545 50.4065 63.6086L51.9352 74.4212C52.3667 77.476 54.981 79.7463 58.0658 79.7463H149.809C153.572 79.7463 156.465 83.0767 155.939 86.8041H155.938Z",
    fill: "url(#paint2_linear_2973_9870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.355 125.978H33.6796C33.1771 125.978 32.6919 125.794 32.315 125.462C31.938 125.13 31.6951 124.671 31.6318 124.173L30.4848 115.092C30.4484 114.801 30.4741 114.506 30.5604 114.226C30.6466 113.947 30.7913 113.688 30.985 113.469C31.1787 113.249 31.4168 113.073 31.6836 112.953C31.9504 112.832 32.2398 112.77 32.5326 112.77H126.502C126.794 112.77 127.084 112.832 127.351 112.953C127.617 113.073 127.856 113.249 128.049 113.469C128.243 113.688 128.388 113.947 128.474 114.226C128.56 114.506 128.586 114.801 128.549 115.092L127.402 124.173C127.339 124.671 127.096 125.13 126.719 125.462C126.342 125.794 125.857 125.978 125.355 125.978V125.978Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2973_9870",
    x1: 83.1474,
    y1: 61.9082,
    x2: 4.84695,
    y2: -16.3929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2973_9870",
    x1: 62.4043,
    y1: 84.198,
    x2: 38.2071,
    y2: 60.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2973_9870",
    x1: 77.9999,
    y1: 58.2842,
    x2: 77.9999,
    y2: 153.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2973_9870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultRecordPreview);
export default __webpack_public_path__ + "static/media/default-record-preview.b5c7268a4d318e26c7ca5605648844bc.svg";
export { ForwardRef as ReactComponent };